export default __webpack_public_path__ + "static/media/product-image-hover-15.f9c56bbb.jpg";